import type {inferRouterInputs} from "@trpc/server";
import type {ZodFormattedError} from "zod";
import type {AppRouter} from "@app-trpc/server/api/trpc/[trpc]";

export type CreateSocialMediaDataInput = inferRouterInputs<AppRouter>['socialMedia']['create'];
export type UpdateSocialMediaDataInput = inferRouterInputs<AppRouter>['socialMedia']['update'];

export const useSocialMediaClient = () => {
  const client = useNuxtApp().$client;

  async function findAll() {
    return client.socialMedia.findAll.query();
  }

  async function findById(id: number) {
    return client.socialMedia.findById.query(id);
  }

  async function create(data: CreateSocialMediaDataInput): Promise<{
    validationErrors: ZodFormattedError<CreateSocialMediaDataInput>
  } | undefined> {
    try {
      await client.socialMedia.create.mutate(data);
    } catch (e) {
      if (isTRPCClientError(e)) { // TODO: simplify
        const zodError = e.data?.zodError as ZodFormattedError<CreateSocialMediaDataInput>;
        return {
          validationErrors: zodError
        }
      }
    }
  }

  async function updateById(data: UpdateSocialMediaDataInput): Promise<{
    validationErrors: ZodFormattedError<CreateSocialMediaDataInput>
  } | undefined> {
    try {
      await client.socialMedia.update.mutate(data);
    } catch (e) {
      if (isTRPCClientError(e)) { // TODO: simplify
        const zodError = e.data?.zodError as ZodFormattedError<CreateSocialMediaDataInput>;
        return {
          validationErrors: zodError
        }
      }
    }
  }

  async function deleteById(id: number) {
    return client.socialMedia.delete.mutate(id);
  }


  return {
    findAll,
    findById,
    create,
    updateById,
    deleteById,
  }
}